var _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduceProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.64,139.7a29.63,29.63,0,0,1,7.23-3.14l1.49-7.16,12.1-.21,1.74,7.1a29.58,29.58,0,0,1,7.35,2.89l6.11-4,8.71,8.41-3.79,6.25a29.46,29.46,0,0,1,3.14,7.23l7.16,1.49.21,12.1-7.1,1.74a29.75,29.75,0,0,1-2.89,7.34l4,6.12-8.41,8.7-6.25-3.79a29.66,29.66,0,0,1-7.23,3.15l-1.49,7.16-12.1.21-1.74-7.1a29.75,29.75,0,0,1-7.34-2.89l-6.12,4-8.71-8.41,3.79-6.25a29.63,29.63,0,0,1-3.14-7.23l-7.16-1.5L361,159.82l7.1-1.75a30.06,30.06,0,0,1,2.89-7.34l-4-6.11,8.41-8.71,6.25,3.79Zm6.45,16.12a13,13,0,1,0,18.35-.32A13,13,0,0,0,388.09,155.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.09,155.82a9.73,9.73,0,0,1,2.42-2.12,12.86,12.86,0,0,1,8.46-2,13.06,13.06,0,0,1,5.76,2,13.25,13.25,0,0,1,4.65,5.25,12.35,12.35,0,0,1,1.19,3.64,12.75,12.75,0,0,1,.07,4,13.27,13.27,0,0,1-11,11.35,12.8,12.8,0,0,1-4,.07A12.22,12.22,0,0,1,392,177a13.31,13.31,0,0,1-5.41-4.46,13.15,13.15,0,0,1-.54-14.22,9.89,9.89,0,0,1,2-2.49,30.72,30.72,0,0,0-1.79,2.64,13,13,0,0,0-1.43,8.31,12.7,12.7,0,0,0,7.41,9.6,12.76,12.76,0,0,0,7.28.89,12.6,12.6,0,0,0,10.36-10.73,12.85,12.85,0,0,0-1.15-7.24,12.7,12.7,0,0,0-9.86-7.07,12.91,12.91,0,0,0-8.25,1.73C388.91,155,388.15,155.89,388.09,155.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.64,139.7a2.71,2.71,0,0,1-.41-.21L380,138.8,375.32,136l.15,0-8.35,8.75,0-.23,4,6.09.07.11-.06.12a29.29,29.29,0,0,0-2.84,7.29l0,.15-.14,0-7.1,1.76.2-.26q.12,5.72.24,12.1l-.23-.28,7.16,1.47.19,0,.05.18a29.06,29.06,0,0,0,3.12,7.15l.1.17-.1.17L368,187.06l-.05-.41,8.71,8.4-.43,0,6.11-4,.18-.11.19.1a29.23,29.23,0,0,0,7.25,2.85l.21,0,.06.21c.54,2.23,1.14,4.65,1.74,7.1l-.36-.27,12.1-.22-.36.29,1.49-7.16,0-.22.22-.06a28.9,28.9,0,0,0,7.13-3.1h0l.19-.12.2.12,6.25,3.79-.46.06,8.4-8.71,0,.46-4-6.12-.13-.18.11-.19a29.35,29.35,0,0,0,2.86-7.25l.05-.22.21-.05,7.11-1.73-.27.35q-.11-6.19-.2-12.1l.27.33-7.16-1.5-.2,0-.05-.2a29.6,29.6,0,0,0-3.1-7.16l-.1-.16.1-.17,3.8-6.25,0,.39-8.69-8.42.36,0-6.13,4-.13.09-.14-.08a29.72,29.72,0,0,0-7.27-2.88l-.15,0,0-.14c-.63-2.59-1.19-4.91-1.72-7.11l.22.17-12.1.16.16-.14c-.62,2.86-1.12,5.2-1.54,7.15v.08h-.07a31.84,31.84,0,0,0-5.54,2.13l-1.3.68a3,3,0,0,1-.43.22l.4-.27c.28-.17.7-.43,1.28-.74a29,29,0,0,1,5.52-2.25l-.08.09c.39-1.95.86-4.3,1.44-7.17l0-.13h.13l12.1-.26h.17l.05.17c.54,2.2,1.12,4.52,1.76,7.1l-.18-.18a30.33,30.33,0,0,1,7.42,2.89h-.28l6.1-4,.19-.12.17.16,8.72,8.38.18.17-.13.22L422.85,150v-.33A30.17,30.17,0,0,1,426,157l-.25-.23,7.16,1.48.27.05v.28q.12,5.89.23,12.1v.28l-.27.07-7.11,1.74.27-.26a30.22,30.22,0,0,1-2.92,7.43v-.38l4,6.12.16.24-.21.21-8.4,8.71-.2.22-.26-.16-6.25-3.79h.38a30.22,30.22,0,0,1-7.32,3.18l.26-.29-1.49,7.16-.06.29h-.3l-12.1.21h-.29l-.07-.28c-.6-2.45-1.19-4.88-1.73-7.11l.26.27a30.3,30.3,0,0,1-7.43-2.93l.37,0-6.12,4-.23.15-.2-.19c-3-2.93-6-5.78-8.7-8.42l-.19-.18.14-.23,3.8-6.24v.33a30.13,30.13,0,0,1-3.17-7.32l.24.22-7.16-1.51-.23,0v-.23q-.1-6.37-.19-12.1v-.21l.2-.05,7.11-1.72-.18.18a30.25,30.25,0,0,1,2.94-7.39v.22l-4-6.13-.08-.12.11-.11,8.45-8.66.07-.07.08.05,4.6,2.87,1.19.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.52,211.64a29.63,29.63,0,0,1,7.23-3.14l1.49-7.16,12.1-.22,1.74,7.11a29.36,29.36,0,0,1,7.34,2.89l6.12-4,8.71,8.4-3.8,6.25A29.35,29.35,0,0,1,114.6,229l7.16,1.49.21,12.1-7.1,1.74a29.75,29.75,0,0,1-2.89,7.34l4,6.12-8.41,8.7-6.25-3.79a29.66,29.66,0,0,1-7.23,3.15L92.61,273l-12.1.21-1.74-7.1a30,30,0,0,1-7.35-2.89l-6.11,4-8.71-8.41,3.79-6.25a29.53,29.53,0,0,1-3.14-7.24l-7.16-1.49-.21-12.1L57,230a30.06,30.06,0,0,1,2.89-7.34l-4-6.11,8.41-8.71,6.25,3.79ZM77,227.76a13,13,0,1,0,18.35-.32A13,13,0,0,0,77,227.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,227.76a9.78,9.78,0,0,1,2.41-2.12,12.91,12.91,0,0,1,8.47-2,13.06,13.06,0,0,1,5.76,2,13.25,13.25,0,0,1,4.65,5.25,13.17,13.17,0,0,1,1.26,7.64,13.27,13.27,0,0,1-11,11.35,12.5,12.5,0,0,1-4,.06,12.2,12.2,0,0,1-3.68-1,13.25,13.25,0,0,1-5.41-4.47,13.13,13.13,0,0,1-.54-14.21,9.89,9.89,0,0,1,2-2.49,31.34,31.34,0,0,0-1.79,2.63,13,13,0,0,0-1.43,8.31A12.69,12.69,0,0,0,76,244.11a12.83,12.83,0,0,0,5.18,4.2,12.76,12.76,0,0,0,7.28.89A12.6,12.6,0,0,0,98.8,238.47a12,12,0,0,0-.06-3.78,11.75,11.75,0,0,0-1.09-3.46,12.7,12.7,0,0,0-4.38-5,12.55,12.55,0,0,0-5.48-2,12.91,12.91,0,0,0-8.25,1.73C77.79,227,77,227.83,77,227.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.52,211.64a2.71,2.71,0,0,1-.41-.21l-1.19-.69L64.2,208l.15,0L56,216.69l0-.24,4,6.1.07.11-.06.12a29.29,29.29,0,0,0-2.84,7.29l0,.14-.14,0L49.94,232l.2-.26q.12,5.72.24,12.1l-.23-.28L57.31,245l.18,0,.06.18a29.06,29.06,0,0,0,3.12,7.15l.1.17-.1.17c-1.17,1.94-2.47,4.07-3.78,6.25l-.06-.41,8.72,8.4-.43,0,6.11-4,.18-.12.19.11a29.62,29.62,0,0,0,7.25,2.85l.21.05,0,.21c.55,2.22,1.15,4.65,1.75,7.1l-.36-.27,12.1-.22-.36.29,1.49-7.16,0-.22.21-.06a29.18,29.18,0,0,0,7.14-3.1h0l.19-.11.19.11,6.26,3.8-.46.05,8.4-8.7,0,.46-4-6.12-.12-.18.11-.2a29.28,29.28,0,0,0,2.86-7.24l0-.22.21-.05,7.11-1.73-.27.35q-.11-6.19-.2-12.1l.27.33-7.16-1.5-.2,0,0-.2a29.6,29.6,0,0,0-3.1-7.16l-.1-.17.1-.16,3.8-6.25,0,.39-8.69-8.43.36,0-6.13,4-.13.09-.15-.08A29.26,29.26,0,0,0,93,208.47l-.15,0,0-.14c-.63-2.59-1.19-4.91-1.72-7.11l.22.17-12.1.15.16-.13c-.62,2.86-1.12,5.2-1.54,7.15l0,.07-.06,0a31,31,0,0,0-5.54,2.13l-1.3.68a3,3,0,0,1-.43.22l.4-.27c.28-.17.7-.43,1.28-.74a29,29,0,0,1,5.52-2.25l-.08.09c.39-1.95.86-4.3,1.44-7.17l0-.13h.13l12.1-.27h.17l0,.17c.54,2.2,1.12,4.52,1.76,7.1l-.18-.18a29.72,29.72,0,0,1,7.41,2.89h-.27l6.1-4,.19-.12.17.15c2.75,2.66,5.65,5.44,8.72,8.39l.18.17-.13.21c-1.23,2-2.48,4.12-3.78,6.26v-.33a30.17,30.17,0,0,1,3.19,7.31l-.25-.24,7.16,1.49.27.05v.28q.12,5.89.23,12.09v.29l-.27.06L115,244.68l.27-.26a30.22,30.22,0,0,1-2.92,7.43v-.38l4,6.12.16.24-.21.21-8.4,8.71-.21.21-.25-.15L101.14,263h.38a29.83,29.83,0,0,1-7.32,3.18l.26-.28L93,273.08l-.06.29h-.3l-12.1.2h-.29l-.07-.28c-.6-2.46-1.19-4.88-1.73-7.11l.26.27a30.7,30.7,0,0,1-7.43-2.93l.37,0-6.12,4-.23.15-.2-.19-8.7-8.42-.19-.18.14-.23,3.8-6.25v.34A30.29,30.29,0,0,1,57,245.43l.24.21L50,244.14l-.23,0v-.23q-.11-6.37-.19-12.1v-.21l.2-.05,7.11-1.72-.18.17a30.17,30.17,0,0,1,2.94-7.38v.22l-4-6.13-.08-.13.11-.1,8.45-8.66.07-.07.08.05,4.6,2.87,1.19.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,73.59a21.69,21.69,0,0,1,5.24-2.28l1.08-5.19,8.77-.15,1.26,5.15a21.41,21.41,0,0,1,5.32,2.09l4.43-2.91,6.31,6.1-2.74,4.52a21.34,21.34,0,0,1,2.27,5.25l5.19,1.08.16,8.77-5.15,1.26a21.56,21.56,0,0,1-2.09,5.32l2.9,4.43L431,113.34l-4.53-2.75a21.69,21.69,0,0,1-5.24,2.28l-1.08,5.19-8.77.15-1.26-5.15a21.41,21.41,0,0,1-5.32-2.09l-4.43,2.91-6.31-6.1,2.74-4.53A21.11,21.11,0,0,1,394.54,98l-5.19-1.08-.16-8.77,5.15-1.26a21.41,21.41,0,0,1,2.09-5.32l-2.9-4.43,6.09-6.31,4.53,2.75Zm4.67,11.68A9.41,9.41,0,1,0,422.13,85,9.41,9.41,0,0,0,408.82,85.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,85.27a7.41,7.41,0,0,1,1.76-1.54,9.49,9.49,0,0,1,10.3,0,9.72,9.72,0,0,1,3.38,3.8,9.79,9.79,0,0,1,.91,5.54,9.64,9.64,0,0,1-7.95,8.23,9.05,9.05,0,0,1-2.89,0,8.83,8.83,0,0,1-2.67-.76,9.69,9.69,0,0,1-3.92-3.24,9.56,9.56,0,0,1-1.63-4.11,9.41,9.41,0,0,1,1.24-6.19,7.32,7.32,0,0,1,1.47-1.8c.06,0-.56.62-1.29,1.91a9.36,9.36,0,0,0-1,6,9.25,9.25,0,0,0,5.37,7,8.53,8.53,0,0,0,2.54.7,8.42,8.42,0,0,0,2.74-.06,9.09,9.09,0,0,0,7.5-7.77,9.28,9.28,0,0,0-.83-5.25,9.21,9.21,0,0,0-7.14-5.12,9.35,9.35,0,0,0-6,1.25C409.42,84.68,408.87,85.32,408.82,85.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,73.59a1.36,1.36,0,0,1-.29-.15l-.87-.51-3.42-2,.11,0-6.05,6.35v-.17l2.93,4.42.05.08-.05.08a21.83,21.83,0,0,0-2.06,5.28l0,.11-.11,0-5.14,1.28.14-.19c.06,2.76.12,5.69.18,8.77l-.17-.21,5.19,1.07.13,0,0,.13a21.2,21.2,0,0,0,2.26,5.18l.08.12-.08.13-2.74,4.53,0-.3,6.32,6.08-.31,0c1.38-.91,2.89-1.91,4.43-2.91l.13-.09.13.08a21.35,21.35,0,0,0,5.26,2.06l.15,0,0,.15c.4,1.61.83,3.37,1.27,5.15l-.27-.2,8.77-.16-.26.21c.34-1.64.71-3.4,1.08-5.19l0-.16.15,0a21.15,21.15,0,0,0,5.18-2.25h0l.14-.08.14.08,4.53,2.75-.33,0,6.09-6.31,0,.33L434,102.74l-.08-.13.07-.14A20.65,20.65,0,0,0,436,97.22l0-.16.16,0,5.15-1.25-.2.25c-.05-3-.1-5.92-.15-8.77l.2.24L436,86.41l-.14,0,0-.14a21.25,21.25,0,0,0-2.24-5.18l-.08-.13.08-.12,2.75-4.52,0,.28-6.3-6.11.26,0-4.44,2.89-.1.06-.1-.05a21.25,21.25,0,0,0-5.27-2.09l-.1,0,0-.1c-.45-1.87-.86-3.56-1.24-5.15l.15.12-8.76.11.11-.09c-.44,2.07-.81,3.76-1.11,5.18v0h-.05a22.14,22.14,0,0,0-4,1.55l-1,.49a1.53,1.53,0,0,1-.31.16,1.88,1.88,0,0,1,.29-.2c.2-.12.51-.31.93-.53a20.71,20.71,0,0,1,4-1.63l-.06.06c.28-1.41.63-3.12,1-5.19l0-.1h.1l8.77-.19h.12l0,.12c.39,1.59.81,3.27,1.27,5.14l-.12-.13a21.69,21.69,0,0,1,5.37,2.1h-.2l4.42-2.92.14-.09.12.12q3,2.88,6.32,6.07l.13.13-.1.15L434,81.05V80.8a22.51,22.51,0,0,1,2.31,5.3l-.19-.17L441.33,87l.2,0v.19c.05,2.86.11,5.78.16,8.77v.21l-.2,0-5.15,1.26.19-.19a21.56,21.56,0,0,1-2.11,5.39v-.28l2.9,4.43.12.18-.15.15-6.09,6.31-.15.16-.18-.11-4.53-2.75h.27a21.77,21.77,0,0,1-5.3,2.31l.19-.21-1.08,5.19-.05.21h-.21l-8.77.15h-.21l-.05-.21c-.43-1.77-.86-3.53-1.26-5.14l.19.19a21.65,21.65,0,0,1-5.38-2.13H405l-4.44,2.9-.16.11-.15-.14-6.3-6.1-.14-.14.1-.16,2.76-4.53v.25a22,22,0,0,1-2.3-5.31l.17.16-5.19-1.09-.16,0v-.16c0-3.08-.09-6-.13-8.77V88l.15,0,5.15-1.25-.13.13a21.2,21.2,0,0,1,2.13-5.35v.16c-1-1.6-2-3.1-2.89-4.44l-.05-.1.07-.07,6.13-6.28.05,0,.05,0c1.45.9,2.57,1.59,3.34,2.08l.86.54A3.52,3.52,0,0,1,404.15,73.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93,48.89a21.76,21.76,0,0,1,5.25-2.28l1.08-5.19,8.76-.15,1.27,5.15a21.33,21.33,0,0,1,5.32,2.09L156,45.6l6.31,6.09-2.75,4.53a21.76,21.76,0,0,1,2.28,5.25l5.19,1.08.15,8.77-5.15,1.26A21.72,21.72,0,0,1,160,77.9l2.9,4.43-6.09,6.31-4.53-2.75A21.69,21.69,0,0,1,147,88.17l-1.08,5.19-8.77.15-1.26-5.15a21.41,21.41,0,0,1-5.32-2.09l-4.43,2.9-6.31-6.09,2.75-4.53a21.52,21.52,0,0,1-2.28-5.24l-5.19-1.08L115,63.46l5.14-1.26a21.44,21.44,0,0,1,2.1-5.32l-2.91-4.43,6.09-6.31,4.53,2.75Zm4.68,11.68a9.41,9.41,0,1,0,13.3-.24A9.4,9.4,0,0,0,134.61,60.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.61,60.57A7.19,7.19,0,0,1,136.36,59a9.51,9.51,0,0,1,10.31,0,9.62,9.62,0,0,1,3.37,3.8A9.57,9.57,0,0,1,151,68.4,9.59,9.59,0,0,1,143,76.62a9.67,9.67,0,0,1-5.57-.71,9.6,9.6,0,0,1-3.91-3.24,9.5,9.5,0,0,1-.4-10.3,6.94,6.94,0,0,1,1.48-1.8,22.24,22.24,0,0,0-1.29,1.91,9.36,9.36,0,0,0-1,6,9.06,9.06,0,0,0,1.61,3.91,9.29,9.29,0,0,0,3.76,3,8.55,8.55,0,0,0,2.53.7,8.42,8.42,0,0,0,2.74-.06,9.16,9.16,0,0,0,5-2.65,9.28,9.28,0,0,0,2.48-5.12,9,9,0,0,0,0-2.74,8.47,8.47,0,0,0-.8-2.51A9.21,9.21,0,0,0,142.45,58a9.37,9.37,0,0,0-6,1.25A21.26,21.26,0,0,0,134.61,60.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93,48.89l-.29-.16-.87-.5-3.41-2,.1,0-6,6.35,0-.17c.88,1.34,1.87,2.82,2.92,4.42l.05.07,0,.09a20.89,20.89,0,0,0-2.06,5.28l0,.11-.1,0L115,63.65l.15-.19c0,2.76.11,5.69.17,8.77l-.17-.21,5.19,1.07.14,0,0,.13a21.63,21.63,0,0,0,2.27,5.18l.07.12-.07.12-2.74,4.54,0-.3L126.33,89,126,89l4.43-2.9.13-.09.14.08A21.52,21.52,0,0,0,136,88.11l.16,0,0,.15c.4,1.61.83,3.37,1.27,5.15l-.26-.2,8.76-.16-.25.21,1.08-5.19,0-.16.16,0a21.25,21.25,0,0,0,5.17-2.25h0l.14-.08.14.08,4.53,2.75-.33,0,6.09-6.31,0,.33L159.76,78l-.09-.13.08-.14a21.33,21.33,0,0,0,2.07-5.26l0-.15.15,0,5.15-1.25-.2.25c-.05-3-.09-5.92-.14-8.77l.2.24-5.19-1.09-.15,0,0-.14a21.08,21.08,0,0,0-2.24-5.18l-.07-.13.07-.12,2.75-4.52,0,.28-6.3-6.11.26,0-4.44,2.89-.1.06-.1,0a21,21,0,0,0-5.27-2.09l-.1,0,0-.1c-.45-1.88-.86-3.56-1.24-5.15l.16.12-8.77.11.11-.09c-.44,2.07-.8,3.76-1.11,5.18v0h-.05a22.14,22.14,0,0,0-4,1.55l-.94.49-.32.16a1.74,1.74,0,0,1,.3-.2c.2-.12.5-.31.92-.53a20.71,20.71,0,0,1,4-1.63l-.06.06c.29-1.42.63-3.12,1-5.19l0-.1h.09l8.77-.19h.13l0,.12c.39,1.59.81,3.27,1.28,5.14l-.13-.13a21.54,21.54,0,0,1,5.37,2.1h-.2l4.42-2.92.14-.09.12.12,6.32,6.07.13.13-.09.15-2.74,4.54V56.1a21.72,21.72,0,0,1,2.31,5.3l-.18-.17,5.19,1.07.19,0v.2c.06,2.85.11,5.78.17,8.77v.21l-.2,0-5.15,1.27.2-.19A22.14,22.14,0,0,1,160.21,78v-.28l2.91,4.43.11.18-.14.15L157,88.82l-.15.16-.19-.11-4.53-2.75h.28a21.84,21.84,0,0,1-5.31,2.31l.19-.21-1.08,5.19,0,.21h-.22l-8.76.16H137l-.05-.21c-.44-1.77-.87-3.53-1.26-5.14l.19.19a21.65,21.65,0,0,1-5.38-2.13h.26l-4.43,2.9-.17.11-.14-.13-6.31-6.1-.13-.14.1-.16c.95-1.58,1.9-3.12,2.75-4.53v.24a21.32,21.32,0,0,1-2.29-5.3l.16.16-5.18-1.09-.17,0v-.17c0-3.07-.09-6-.14-8.76v-.16l.15,0L120.08,62l-.13.13a21.58,21.58,0,0,1,2.13-5.35V57c-1-1.6-2-3.1-2.88-4.44l-.06-.1.07-.07,6.13-6.28,0,0,.06,0,3.33,2.08.86.54A1.39,1.39,0,0,1,129.93,48.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.88,76.2v0l-.95-3.87a16.81,16.81,0,0,1-4-1.57l-3.35,2.19h0l-4.79-4.62h0l2.07-3.41a16.22,16.22,0,0,1-1.71-3.94l-3.92-.82v0l-.11-6.64h0l3.87-1a16.81,16.81,0,0,1,1.57-4l-2.19-3.35h0L353,40.36h0l3.41,2.06a16.62,16.62,0,0,1,3.94-1.71l.82-3.92h0l6.65-.12v0l.95,3.87a16.43,16.43,0,0,1,4,1.58l3.35-2.2h0L381,44.58v0L378.88,48A16.27,16.27,0,0,1,380.59,52l3.92.81v0l.12,6.65h0l-3.87,1a16.43,16.43,0,0,1-1.58,4l2.2,3.35v0l-4.62,4.78h0l-3.41-2.07a16.12,16.12,0,0,1-3.95,1.71l-.81,3.93h0Zm-4.95-5.52h0a16,16,0,0,0,4,1.57h0l.95,3.87,6.59-.11.81-3.92h0a16.54,16.54,0,0,0,4-1.72h0l3.4,2.06,4.58-4.73-2.19-3.35h0a15.73,15.73,0,0,0,1.58-4v0h0l3.87-1-.12-6.59L380.55,52v0A16.12,16.12,0,0,0,378.83,48h0v0l2.06-3.4L376.15,40l-3.34,2.2h0a16,16,0,0,0-4-1.58h0v0l-.94-3.87-6.59.12-.81,3.91h0a15.78,15.78,0,0,0-3.95,1.72h0L353,40.42l-4.58,4.74,2.19,3.34v0a15.78,15.78,0,0,0-1.57,4h0l-3.87,1,.11,6.58,3.92.81v0a16.79,16.79,0,0,0,1.72,4h0l-2.06,3.41,4.74,4.57Zm8.15-7.33a7.1,7.1,0,0,1-7.13-7,7,7,0,0,1,2-5.08h0a7.13,7.13,0,1,1,5.13,12.08Zm0-14.2a7.06,7.06,0,0,0-5.1,2.16h0a7.09,7.09,0,0,0,.18,10,7.08,7.08,0,1,0,4.92-12.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,51.29a5.18,5.18,0,0,1,1.32-1.16,7.08,7.08,0,0,1,4.64-1.1,7.22,7.22,0,0,1,5.7,4,7,7,0,0,1,.64,2,6.63,6.63,0,0,1,0,2.18,7.25,7.25,0,0,1-6,6.22,7.18,7.18,0,0,1-4.2-.54,7.26,7.26,0,0,1-3-2.45,7.18,7.18,0,0,1-.3-7.78A5.23,5.23,0,0,1,360,51.29a15.87,15.87,0,0,0-1,1.44,7,7,0,0,0,.43,7.51,7,7,0,0,0,2.84,2.3,6.44,6.44,0,0,0,1.91.53,6.92,6.92,0,0,0,2.08,0,6.89,6.89,0,0,0,5.67-5.88,6.52,6.52,0,0,0,0-2.07,6.63,6.63,0,0,0-.6-1.89,7.05,7.05,0,0,0-2.4-2.76,7,7,0,0,0-3-1.11,7.07,7.07,0,0,0-4.52.94A17,17,0,0,0,360,51.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.43,42.46l-.22-.11-.65-.38L353,40.44h.08l-4.58,4.8,0-.13c.66,1,1.41,2.13,2.2,3.34l0,.06,0,.06a16.34,16.34,0,0,0-1.56,4l0,.08-.08,0-3.88,1,.11-.15q.06,3.14.13,6.63l-.13-.16,3.92.81.1,0,0,.1A16.28,16.28,0,0,0,351,64.79l.06.09L351,65,349,68.39l0-.22,4.77,4.6-.23,0,3.34-2.19.1-.07.1.06a16.18,16.18,0,0,0,4,1.56l.11,0,0,.11,1,3.89-.2-.15,6.62-.12-.19.16c.26-1.24.53-2.57.81-3.92l0-.12.12,0a16.28,16.28,0,0,0,3.91-1.7h0l.11-.07.1.07,3.42,2.07-.25,0,4.6-4.76,0,.25L379,64.49l-.07-.1.06-.11a15.84,15.84,0,0,0,1.56-4l0-.11.12,0,3.89-1-.15.19c0-2.26-.07-4.47-.11-6.62l.15.18-3.92-.82-.11,0,0-.1a15.64,15.64,0,0,0-1.69-3.92l-.06-.09.06-.1,2.08-3.41,0,.21-4.75-4.62.19,0-3.35,2.19-.08.05-.07-.05a16.57,16.57,0,0,0-4-1.58l-.08,0,0-.07-.94-3.9.12.1-6.63.08.09-.07c-.34,1.56-.61,2.85-.84,3.92v0h0a16.86,16.86,0,0,0-3,1.16l-.71.37-.24.12.22-.15.7-.4a15.45,15.45,0,0,1,3-1.23l-.05,0c.22-1.07.48-2.36.79-3.93l0-.07h.07l6.62-.14h.1l0,.1,1,3.88-.1-.1a16.73,16.73,0,0,1,4.06,1.59h-.15l3.34-2.2.1-.07.09.09L381,44.46l.1.1-.07.11L379,48.1v-.18a16.32,16.32,0,0,1,1.74,4l-.13-.13,3.92.81.14,0v.15q.06,3.22.12,6.62v.16l-.15,0-3.89.95.15-.14a16.65,16.65,0,0,1-1.6,4.07v-.21l2.2,3.35.09.13-.12.12-4.6,4.77-.11.11-.14-.08-3.42-2.08h.21a16.93,16.93,0,0,1-4,1.74l.14-.16c-.28,1.35-.56,2.69-.81,3.92l0,.16h-.16l-6.62.12h-.16l0-.15c-.33-1.35-.65-2.68-.95-3.89l.14.14a16.3,16.3,0,0,1-4.06-1.6h.2l-3.35,2.19-.13.08-.11-.1-4.76-4.61-.1-.1.07-.12c.73-1.19,1.44-2.36,2.08-3.42V65A16.16,16.16,0,0,1,349,61l.13.12-3.92-.82-.13,0V60.1c0-2.32-.07-4.54-.1-6.62v-.12l.11,0,3.89-.94-.1.1a16.63,16.63,0,0,1,1.61-4v.12l-2.18-3.36,0-.07.06-.06L353,40.34l0,0,0,0,2.53,1.57.64.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.42,195.72v0l-1-3.87a16.43,16.43,0,0,1-4-1.58l-3.35,2.2h0l-4.78-4.62v0l2.07-3.41a15.89,15.89,0,0,1-1.71-3.94l-3.93-.81v0L36.65,173h0l3.87-.95a16.81,16.81,0,0,1,1.57-4l-2.19-3.35v0l4.62-4.78h0L48,162a16.62,16.62,0,0,1,3.94-1.71l.82-3.93h0l6.64-.11v0l1,3.87a16.81,16.81,0,0,1,4,1.57l3.35-2.19h0l4.78,4.62h0l-2.06,3.41a16.62,16.62,0,0,1,1.71,3.94l3.92.82v0l.12,6.65h0l-3.87,1a16.43,16.43,0,0,1-1.58,4l2.2,3.35h0L68.27,192h0L64.84,190a16.27,16.27,0,0,1-3.94,1.71l-.81,3.92h0Zm-5-5.52h0a16,16,0,0,0,4,1.58h0l1,3.87,6.59-.11.81-3.92h0a16.12,16.12,0,0,0,3.95-1.71h0l3.4,2.06,4.58-4.74-2.19-3.34h0a15.65,15.65,0,0,0,1.58-4h0l3.87-.94L76,172.32l-3.91-.81v0a16.12,16.12,0,0,0-1.71-4v0h0l2.06-3.41-4.74-4.57-3.34,2.19h0a15.65,15.65,0,0,0-4-1.58h0l-.94-3.87-6.59.11L52,160.28h0A16.54,16.54,0,0,0,48,162h0l-3.41-2.06L40,164.68,42.17,168h0a15.65,15.65,0,0,0-1.58,4h0L36.7,173l.11,6.59,3.92.81v0a16.54,16.54,0,0,0,1.72,3.95h0v0l-2.06,3.4,4.74,4.58Zm8.15-7.33a7.12,7.12,0,0,1-7.13-7,7,7,0,0,1,2-5.08,7.13,7.13,0,1,1,5.13,12.08Zm0-14.21h-.13a7.24,7.24,0,1,0,.13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,170.81a5.31,5.31,0,0,1,1.32-1.17,7.09,7.09,0,0,1,4.64-1.09,7.19,7.19,0,0,1,3.15,1.12,7.37,7.37,0,0,1,2.55,2.87,7,7,0,0,1,.64,2,6.69,6.69,0,0,1,0,2.19,7.25,7.25,0,0,1-6,6.22,7.4,7.4,0,0,1-4.2-.54,7.21,7.21,0,0,1-3-2.45,7.18,7.18,0,0,1-.3-7.78,5.23,5.23,0,0,1,1.12-1.36,14.19,14.19,0,0,0-1,1.44,7,7,0,0,0,3.27,9.8,6.46,6.46,0,0,0,1.91.54,6.62,6.62,0,0,0,2.08-.05,6.87,6.87,0,0,0,5.67-5.87,6.52,6.52,0,0,0,0-2.07,6.69,6.69,0,0,0-.6-1.9,7,7,0,0,0-5.4-3.87,7.13,7.13,0,0,0-4.52.95A14.48,14.48,0,0,0,51.51,170.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,162a.94.94,0,0,1-.22-.12l-.65-.37L44.52,160h.08L40,164.74l0-.12c.66,1,1.41,2.13,2.2,3.33l0,.06,0,.07a16.34,16.34,0,0,0-1.56,4l0,.08-.08,0-3.88,1,.11-.14q.06,3.13.13,6.62l-.13-.15,3.92.81.1,0,0,.1a16,16,0,0,0,1.71,3.91l.06.09-.06.1-2.07,3.42,0-.22,4.77,4.59-.23,0,3.34-2.2.1-.06.1.06a16.17,16.17,0,0,0,4,1.55l.11,0,0,.12,1,3.89-.2-.15,6.62-.12-.19.16c.26-1.24.53-2.58.81-3.92l0-.12.12,0a16.65,16.65,0,0,0,3.91-1.69h0l.11-.06.1.06,3.42,2.08-.25,0,4.6-4.76,0,.25L70.51,184l-.07-.1.06-.11a15.84,15.84,0,0,0,1.56-4l0-.11.12,0,3.89-.95-.15.19c0-2.26-.07-4.47-.11-6.63l.15.18-3.92-.82-.11,0,0-.11a16,16,0,0,0-1.69-3.92l-.06-.09.06-.09L72.32,164l0,.21-4.75-4.61.19,0-3.35,2.19-.08,0-.07,0a16.17,16.17,0,0,0-4-1.58l-.08,0,0-.08-.94-3.89.12.09-6.63.09.09-.07c-.34,1.56-.61,2.84-.84,3.91v0h0a16.43,16.43,0,0,0-3,1.17l-.71.37A1,1,0,0,1,48,162l.22-.15.7-.4a15.45,15.45,0,0,1,3-1.23l-.05.05c.22-1.08.48-2.36.79-3.93l0-.07h.07l6.62-.15h.1l0,.09,1,3.89-.1-.1a16.33,16.33,0,0,1,4.06,1.59h-.15l3.34-2.2.1-.07.09.09L72.58,164l.1.09-.07.12-2.07,3.42v-.18a16.39,16.39,0,0,1,1.74,4l-.13-.13,3.92.81.14,0v.15q.06,3.22.12,6.62v.16l-.15,0-3.89,1,.15-.14a16.81,16.81,0,0,1-1.6,4.07v-.21c.73,1.1,1.46,2.22,2.2,3.35l.09.13-.12.12-4.6,4.76-.11.12-.14-.08-3.42-2.08H65a16.15,16.15,0,0,1-4,1.74l.14-.15c-.28,1.35-.56,2.68-.81,3.92l0,.16h-.16l-6.62.12h-.16l0-.16c-.33-1.34-.65-2.67-1-3.89l.14.15a16.31,16.31,0,0,1-4.06-1.61h.2l-3.35,2.19-.13.08-.11-.1L40.23,188l-.1-.1.07-.13,2.08-3.42v.19a16.16,16.16,0,0,1-1.73-4l.13.12-3.92-.83-.13,0v-.13c0-2.32-.07-4.54-.1-6.62v-.12l.11,0,3.89-.94-.1.1A16.54,16.54,0,0,1,42,168v.13l-2.18-3.36,0-.07,0-.06,4.63-4.74,0,0,0,0,2.53,1.57.64.41A1.77,1.77,0,0,1,48,162Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.26,387.84a32.12,32.12,0,0,0-13.71-4.72c-2.24-.23-4.69-.16-6.49,1.19a1.33,1.33,0,0,0-.66,1.19,1.46,1.46,0,0,0,.63.81,19.62,19.62,0,0,0,20.23,1.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,387.45a67,67,0,0,1-8.86-7.79,22.43,22.43,0,0,1-5.55-10.27,4.12,4.12,0,0,1,.44-3.43c7.06,5.51,12.61,12.64,14,21.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19,387.79a32.23,32.23,0,0,1,.16-11.63,15.72,15.72,0,0,1,6.2-9.6c1.22,2.86.69,6.14-.17,9.12a44.29,44.29,0,0,1-6.14,12.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.11,400.19c-4.2.51-7.86,2.72-11,5.56a20.89,20.89,0,0,0-6.29,10.8c4.12-.25,7.62-3.16,10.15-6.42s4.3-6.83,7.08-9.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.61,402.17a27.12,27.12,0,0,1,3.13-25.65c2.4,8.51,1.52,18.13-3.13,25.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.76,413.06A19.65,19.65,0,0,0,348,423.85c-.23.47-.43,1.06-.12,1.47a1.39,1.39,0,0,0,1.24.37c3.7-.24,7-2.46,9.68-5s5.05-5.45,8-7.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.46,412.47a35,35,0,0,1-.34-19.51c.68-2.51,1.84-5.16,4.16-6.34a.82.82,0,0,1,.64-.11.89.89,0,0,1,.4.47,11.75,11.75,0,0,1,1,5.6,34,34,0,0,1-.88,5.66c-.73,3.46-1.12,7.19-3,10.17a20.93,20.93,0,0,0-1.2,2.24c-.36.76-.37,1-.7,1.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,416.07c-1.79-6.82.11-15.09,4.41-20.68.31-.41.73-.85,1.25-.81.79.08,1,1.13,1,1.93a37.3,37.3,0,0,1-6.62,19.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.85,417.56a30.08,30.08,0,0,0,24.69-5,20,20,0,0,0-13.37-1.64c-4.46,1-8.54,3-11.32,6.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,413c4.64-7.57,13.54-12.5,22.41-12.95-1,3.6-4,6.4-7.33,8.1A40.62,40.62,0,0,1,399,411.31c-1.43.28-3.39.59-4.32,1.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.13,391A65.15,65.15,0,0,0,394,377.86a21.91,21.91,0,0,0-2.62-13c-4.33,8.39-4.77,18.19-.38,26.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.73,383.61c5.07-9.22,15.41-16.58,25.88-17.61-4,10.05-15.05,17.82-25.88,17.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.54,385.41c7.56,1.15,14,6,21.07,8.91a9.41,9.41,0,0,0,4.76.91,3.72,3.72,0,0,0,2.33-6.59,10.11,10.11,0,0,0-3.46-2.1c-7.69-3.21-15.95-3.29-24.05-1.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,390.71c1.71.49,2.3,1.38,3.65,2.54a39.42,39.42,0,0,0,16,8.2c.61.15,1.41.22,1.71-.34s-.07-1.06-.41-1.49a22,22,0,0,0-9.65-6.55c-3.68-1.37-6.88-3-11.28-2.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22,358.68a30.24,30.24,0,0,0,23.19,7.89,1.56,1.56,0,0,0,1-.38c.58-.63-.12-1.61-.8-2.14-6.81-5.32-15.07-7.52-23.44-5.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.08,356.54A32.31,32.31,0,0,1,428,351.77a22.94,22.94,0,0,1-13.78,6.05,43.45,43.45,0,0,1-15.14-1.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.75,341.82c-.67-6.8-.23-12.17-.71-19,0-.55-.15-1.21-.66-1.4-.71-.28-1.31.6-1.54,1.32a21.76,21.76,0,0,0,2.9,18.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.26,342.58a40.13,40.13,0,0,0,11.27-11c2.23-3,4.1-6.69,3.6-10.43a10.77,10.77,0,0,0-8.13,4,22.81,22.81,0,0,0-4.15,8.33c-.9,3-1.53,6.07-2.59,9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.33,339.5a91,91,0,0,0,27.74-16.35c-3.32-1.34-7.11-.54-10.42.8a32.81,32.81,0,0,0-17.46,15.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.37,346.3a56.34,56.34,0,0,0,15.4.07c5-.83,9.71-2.81,14.38-4.77a1.7,1.7,0,0,0,1-.75,1.15,1.15,0,0,0-.35-1.23,3,3,0,0,0-1.23-.57c-5.07-1.42-10.55-.76-15.54.93a71.82,71.82,0,0,0-13.64,6.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14,358.92c-3.49-7.05-3.26-15.28-.25-22.55,2.13,3.24,2.39,7.36,2,11.21s-1.56,7.82-1.64,11.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.19,351.88a31.47,31.47,0,0,0-23.37,9.95,21.82,21.82,0,0,0,12.8-2.37,64.12,64.12,0,0,0,11-7.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.81,348.74c-4.27-.34-8.37-.87-12.47.39a14.92,14.92,0,0,0-9.51,8.06A22.48,22.48,0,0,0,336.52,355a66.69,66.69,0,0,0,10.29-6.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7,348.89c-3.84-2.52-7.78-5.08-12.25-6.12s-9.65-.27-12.76,3.09c3.61,2.13,8,2.38,12.2,2.38s9.33-.06,13.29,1.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.72,349.09c-6.56-6.44-9.05-18-6.41-26.83a40.87,40.87,0,0,1,6.41,26.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,330.83C380,328,380.87,324.94,382,322a25.22,25.22,0,0,1,4.59-8.13,12.1,12.1,0,0,1,8.12-4.22,32.68,32.68,0,0,1-15.77,21.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5,334.64c-2.05-2.82-4.42-6.65-7.19-8.75s-6.4-3.38-9.78-2.57a22.78,22.78,0,0,0,17,11.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.15,331.07a49.26,49.26,0,0,1-3.24-10.48,16.39,16.39,0,0,1,1.64-10.66c3.61,6.81,4.77,14.11,1.78,21.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,309.93c2-6.75,8.22-11.72,14.89-14a5.46,5.46,0,0,1,2.61-.39,2.25,2.25,0,0,1,1.92,1.6c.25,1.15-.7,2.18-1.59,2.94a50.69,50.69,0,0,1-17.83,9.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,304.41c.26-4.35.53-8.77,1.94-12.89s4.15-8,8.12-9.8c.67,4.4-1.27,8.77-3.61,12.55s-5.15,7.36-6.56,11.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,307.4c-1.68-4.91-1.86-11.16-4.8-15.45-2.06-3-5.36-5-7.13-8.2a12.47,12.47,0,0,0,.41,9.31,26.83,26.83,0,0,0,5.45,7.8c2.18,2.33,4.05,4.08,6.07,6.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,452.25c-.14,0-.25-32.81-.26-73.28s.09-73.28.22-73.28.25,32.8.26,73.28S378.93,452.25,378.8,452.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.47,354a7.44,7.44,0,0,1-1.24.46l-3.39,1.14c-2.86,1-6.8,2.39-11.06,4.14S383.56,363,381.3,365a7.6,7.6,0,0,0-2.11,2.79c-.33.77-.38,1.24-.43,1.23a1.1,1.1,0,0,1,0-.34,4.53,4.53,0,0,1,.24-1,7.38,7.38,0,0,1,2.05-3,18.39,18.39,0,0,1,4.55-2.82c1.82-.85,3.84-1.74,6-2.62,4.28-1.75,8.24-3.12,11.14-4,1.44-.46,2.62-.79,3.44-1A6.19,6.19,0,0,1,407.47,354Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.87,330.88a2.17,2.17,0,0,1-.35.37l-1,1-3.93,3.57-13.08,11.65c-5.11,4.54-9.52,8.89-12.58,12.16-1.53,1.63-2.74,3-3.56,3.93l-.95,1.08a1.87,1.87,0,0,1-.36.36,2.93,2.93,0,0,1,.28-.42c.2-.26.49-.65.89-1.14.78-1,1.95-2.37,3.45-4a165,165,0,0,1,12.51-12.29c5.12-4.53,9.79-8.61,13.18-11.54l4-3.46,1.11-.92A2.2,2.2,0,0,1,416.87,330.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,352.08c-.13-.06.94-2.52,2-5.64s1.58-5.74,1.71-5.72a19.11,19.11,0,0,1-1.26,5.87,41,41,0,0,1-1.59,4A6.12,6.12,0,0,1,392.94,352.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.83,371.94A5.65,5.65,0,0,1,378,371l-2-2.59c-1.69-2.19-4-5.21-6.66-8.52s-5-6.27-6.78-8.42c-.82-1-1.52-1.87-2.06-2.55a5.4,5.4,0,0,1-.71-1,6.53,6.53,0,0,1,.85.85c.52.57,1.27,1.41,2.18,2.46,1.81,2.09,4.27,5,6.9,8.34s4.92,6.37,6.55,8.61c.81,1.12,1.46,2,1.9,2.68A7.25,7.25,0,0,1,378.83,371.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.54,363.87a11.56,11.56,0,0,1-2.64-4.93,14.22,14.22,0,0,1-.59-5h.21a1.72,1.72,0,0,1-.2.58s0-.22,0-.61l.21,0a22.24,22.24,0,0,0,.84,4.83A37.57,37.57,0,0,0,372.54,363.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,353.66a8,8,0,0,0-1.84-1.07,12.25,12.25,0,0,0-5.1-.41,31.35,31.35,0,0,0-5.14.83,14,14,0,0,1-2.12.51,7.61,7.61,0,0,1,2-.83,23.07,23.07,0,0,1,5.19-1,11.08,11.08,0,0,1,5.27.57A3.24,3.24,0,0,1,364.42,353.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5,351.18c0,.08-1.07-.43-2.82-1a28.23,28.23,0,0,0-14.2-1.08c-1.81.32-2.91.66-2.94.58a3,3,0,0,1,.75-.32,17.22,17.22,0,0,1,2.13-.59,25.06,25.06,0,0,1,14.37,1.09,16.61,16.61,0,0,1,2,.92A2.61,2.61,0,0,1,362.5,351.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.76,340.72a60.75,60.75,0,0,1-2.05-7.14,60,60,0,0,1-1.6-7.25,57.42,57.42,0,0,1,2.06,7.14A58.69,58.69,0,0,1,378.76,340.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,340.72a34.38,34.38,0,0,0-2.27-4.27,18.91,18.91,0,0,0-3.36-3.46,3,3,0,0,1,1.3.67,10.27,10.27,0,0,1,2.44,2.51A9.36,9.36,0,0,1,378.89,340.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,434.76c-.06,0-.15-.79-.52-2.18a32.11,32.11,0,0,0-2.19-5.68,78.84,78.84,0,0,0-11.64-16.39c-2.6-3-5.12-5.77-7.25-8.45a57.93,57.93,0,0,1-5.19-7.48,36.34,36.34,0,0,1-2.62-5.55c-.24-.69-.42-1.22-.52-1.59a2.37,2.37,0,0,1-.13-.57s.28.75.82,2.09a40.38,40.38,0,0,0,2.74,5.45,62.42,62.42,0,0,0,5.24,7.38c2.14,2.65,4.67,5.43,7.27,8.41,5.25,5.9,9.37,11.84,11.58,16.55a28.94,28.94,0,0,1,2.07,5.78c.15.72.25,1.27.29,1.65A5,5,0,0,1,378.8,434.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.71,405.5s-.49.28-1.36.76a28.84,28.84,0,0,0-3.52,2.33,40.05,40.05,0,0,0-4.63,4.21c-1.62,1.72-3.3,3.71-5,5.85-3.42,4.28-6.61,8.07-8.52,11.09-1,1.5-1.68,2.77-2.14,3.65a11.45,11.45,0,0,1-.74,1.37s0-.14.12-.38.24-.62.46-1.07a35.34,35.34,0,0,1,2-3.75,119.53,119.53,0,0,1,8.43-11.21c1.71-2.14,3.4-4.13,5.05-5.85a38.07,38.07,0,0,1,4.74-4.18,25.26,25.26,0,0,1,3.64-2.23c.45-.22.82-.36,1.06-.47S404.7,405.48,404.71,405.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.21,415a19.91,19.91,0,0,1-2.87.42,36.63,36.63,0,0,0-6.8,1.34,20.26,20.26,0,0,0-6.1,3.2c-1.4,1.08-2.07,2-2.13,1.93s.11-.26.42-.66a10.36,10.36,0,0,1,1.5-1.53,18.26,18.26,0,0,1,6.16-3.39,30.91,30.91,0,0,1,6.92-1.23A15.7,15.7,0,0,1,405.21,415Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15,420.83c-.15-.08,1.14-2.06,2.14-4.71s1.16-5,1.33-5a4.66,4.66,0,0,1,0,1.54,16.94,16.94,0,0,1-.84,3.63,17.24,17.24,0,0,1-1.67,3.32A4.62,4.62,0,0,1,388.15,420.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.1,380a3,3,0,0,1-.46.24l-1.35.61c-.59.26-1.31.58-2.12,1s-1.75.85-2.74,1.45l-1.57.89c-.54.31-1.08.68-1.65,1-1.15.7-2.31,1.56-3.54,2.44A60.77,60.77,0,0,0,386,401.81c-.84,1.26-1.66,2.45-2.33,3.62-.33.59-.69,1.14-1,1.69l-.84,1.6c-.55,1-.95,2-1.34,2.79s-.7,1.55-.93,2.14L379,415a2.53,2.53,0,0,1-.22.47,1.81,1.81,0,0,1,.13-.5l.49-1.4c.21-.61.48-1.35.86-2.19s.74-1.81,1.29-2.84l.81-1.61c.29-.57.63-1.12,1-1.72.65-1.19,1.46-2.39,2.3-3.67a58.58,58.58,0,0,1,13.75-14.23c1.25-.88,2.42-1.74,3.59-2.43.58-.35,1.13-.71,1.68-1l1.59-.87c1-.58,2-1,2.79-1.38a22.62,22.62,0,0,1,2.16-.94l1.38-.53A2,2,0,0,1,413.1,380Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,393.75a3.3,3.3,0,0,1,1.13-1.68,7.09,7.09,0,0,1,4.54-1.75,12.44,12.44,0,0,1,4.78.94,6.5,6.5,0,0,1,1.81.88,12.1,12.1,0,0,1-1.92-.57,14.6,14.6,0,0,0-4.65-.77,7.34,7.34,0,0,0-4.34,1.52A13.56,13.56,0,0,0,392.59,393.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.53,396.91a17.4,17.4,0,0,0,1.29-4.2,17.59,17.59,0,0,0-.29-4.38,2.76,2.76,0,0,1,.53,1.22,8.83,8.83,0,0,1,.23,3.22,8.61,8.61,0,0,1-1,3.07C389.93,396.57,389.57,396.94,389.53,396.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.13,439.46c.71,12.54,4.49,25.29,10.3,38.19h25.28c5.54-12.77,9.06-25.5,9.68-38.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.29,459.75c0,.13-8.32.24-18.58.24s-18.59-.11-18.59-.24,8.32-.23,18.59-.23S397.29,459.62,397.29,459.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.73,464.3c0,.13-7.8.23-17.42.23s-17.43-.1-17.43-.23,7.8-.24,17.43-.24S396.73,464.16,396.73,464.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.84,447.7a70.69,70.69,0,0,1,0,11.64,70.69,70.69,0,0,1,0-11.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.38,447.7a75.75,75.75,0,0,1,0,12.05,75.75,75.75,0,0,1,0-12.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09,447.59a78.92,78.92,0,0,1,0,12.3,82.34,82.34,0,0,1,0-12.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.59,447.7c0,.13-9.76.23-21.8.23s-21.8-.1-21.8-.23,9.76-.24,21.8-.24S400.59,447.56,400.59,447.7Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,142.33a72.48,72.48,0,0,1,15.94-11l.17-18,29.06-6.3,7.6,16.3a72.72,72.72,0,0,1,19.08,3.45l12.83-12.59,25,16.1-6.15,16.89a72.48,72.48,0,0,1,11,15.94l18,.17,6.3,29.06-16.29,7.6A72.72,72.72,0,0,1,312.06,219l12.58,12.83-16.09,25-16.89-6.15a73.06,73.06,0,0,1-15.94,11l-.17,18L246.48,286l-7.59-16.29a73.06,73.06,0,0,1-19.08-3.45L207,278.85l-25-16.1,6.15-16.88a73,73,0,0,1-11-15.94l-18-.17-6.3-29.07,16.3-7.6A72.65,72.65,0,0,1,172.55,174L160,161.19l16.1-25L193,142.33Zm16.23,32.86a39.39,39.39,0,1,0,54.44-11.8A39.39,39.39,0,0,0,209.18,175.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,142.33a72.48,72.48,0,0,1,15.94-11l.17-18,29.06-6.3,7.6,16.3a72.72,72.72,0,0,1,19.08,3.45l12.83-12.59,25,16.1-6.15,16.89a72.48,72.48,0,0,1,11,15.94l18,.17,6.3,29.06-16.29,7.6A72.72,72.72,0,0,1,312.06,219l12.58,12.83-16.09,25-16.89-6.15a73.06,73.06,0,0,1-15.94,11l-.17,18L246.48,286l-7.59-16.29a73.06,73.06,0,0,1-19.08-3.45L207,278.85l-25-16.1,6.15-16.88a73,73,0,0,1-11-15.94l-18-.17-6.3-29.07,16.3-7.6A72.65,72.65,0,0,1,172.55,174L160,161.19l16.1-25L193,142.33Zm16.23,32.86a39.39,39.39,0,1,0,54.44-11.8A39.39,39.39,0,0,0,209.18,175.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.18,175.19l.35-.53c.26-.36.61-.88,1.08-1.54l.79-1.13c.32-.41.7-.81,1.09-1.27l1.28-1.47a21.45,21.45,0,0,1,1.59-1.55,37.24,37.24,0,0,1,9.33-6.54,39.35,39.35,0,0,1,14.51-4.06l2.13-.15c.72,0,1.44,0,2.18,0s1.48,0,2.23.1l2.26.27,1.15.15,1.14.25,2.31.52c.78.2,1.53.49,2.31.73a20,20,0,0,1,2.31.84,35.68,35.68,0,0,1,4.53,2.21c.73.43,1.5.83,2.22,1.31l2.14,1.52c.35.27.73.5,1.07.79l1,.88c.66.6,1.36,1.17,2,1.81a41.14,41.14,0,0,1,3.61,4.15,42.76,42.76,0,0,1,3.13,4.71c.45.83.84,1.71,1.28,2.57.2.44.44.86.61,1.32l.51,1.36a44,44,0,0,1,1.72,5.65,45.17,45.17,0,0,1,.78,6l.11,1.52,0,1.53,0,1.53a11.28,11.28,0,0,1-.11,1.54c-.13,1-.26,2-.38,3.08l-.69,3.05a39.25,39.25,0,0,1-13.54,21l-2.5,1.89L262,230.89l-.66.4-.7.34-1.38.67-1.38.67-1.42.53a44.8,44.8,0,0,1-5.76,1.75,45.33,45.33,0,0,1-5.85.78l-1.46.1c-.48,0-1,0-1.45,0-1,0-1.92,0-2.87-.1a42.27,42.27,0,0,1-5.57-.89,43,43,0,0,1-5.28-1.57c-.85-.33-1.66-.73-2.48-1.09l-1.22-.54c-.4-.19-.77-.44-1.16-.65L221.1,230c-.74-.46-1.41-1-2.11-1.49a36,36,0,0,1-3.89-3.2,20.38,20.38,0,0,1-1.72-1.76c-.54-.61-1.12-1.17-1.62-1.8l-1.43-1.89-.7-.93-.61-1c-.4-.65-.79-1.3-1.19-1.94s-.67-1.34-1-2-.65-1.31-.94-2-.49-1.34-.74-2a39.35,39.35,0,0,1-2.31-14.89,37.5,37.5,0,0,1,2.09-11.2c.27-.73.44-1.46.75-2.09l.81-1.77c.26-.55.47-1.06.71-1.51s.49-.84.7-1.2l1-1.61c.22-.36.34-.54.34-.54s-.09.2-.29.57-.52.93-.91,1.64l-.68,1.2c-.23.45-.43,1-.68,1.52l-.78,1.77a22.06,22.06,0,0,0-.73,2.09,37.76,37.76,0,0,0-2,11.14,39.08,39.08,0,0,0,2.37,14.75l.74,2c.29.65.62,1.29.94,2s.6,1.34,1,2,.78,1.28,1.18,1.92l.6,1,.7.92c.47.62,1,1.24,1.42,1.87s1.07,1.17,1.61,1.77a19.8,19.8,0,0,0,1.7,1.73,36.09,36.09,0,0,0,3.86,3.16c.69.49,1.36,1,2.09,1.47l2.25,1.29c.38.21.75.45,1.15.64L226,232c.81.35,1.61.75,2.44,1.07a43,43,0,0,0,5.22,1.54,39.79,39.79,0,0,0,5.51.87c.94.08,1.89.06,2.84.1.47,0,.95,0,1.43,0l1.44-.1a44.1,44.1,0,0,0,5.77-.77,43.17,43.17,0,0,0,5.68-1.74l1.41-.53,1.36-.65,1.37-.67.68-.33.65-.39,2.61-1.61,2.46-1.86a38.68,38.68,0,0,0,13.37-20.76c.23-1,.45-2,.68-3s.25-2,.37-3a9.59,9.59,0,0,0,.11-1.51l0-1.52,0-1.51-.11-1.5a44.34,44.34,0,0,0-.77-5.89,43.22,43.22,0,0,0-1.69-5.57l-.5-1.35c-.16-.45-.4-.87-.6-1.3-.43-.85-.81-1.72-1.26-2.54a40.71,40.71,0,0,0-3.08-4.65,41.62,41.62,0,0,0-3.56-4.12c-.64-.63-1.33-1.19-2-1.78l-1-.88c-.34-.28-.71-.52-1.06-.78-.7-.51-1.41-1-2.1-1.52s-1.48-.86-2.2-1.29a34.37,34.37,0,0,0-4.48-2.2,19.55,19.55,0,0,0-2.28-.84c-.77-.24-1.51-.53-2.28-.73l-2.28-.51-1.13-.26-1.14-.15-2.24-.28c-.73-.11-1.48-.07-2.2-.11s-1.45-.05-2.16,0l-2.11.14a39.23,39.23,0,0,0-14.41,3.95,37.38,37.38,0,0,0-9.32,6.43,21.52,21.52,0,0,0-1.6,1.52l-1.29,1.45c-.4.45-.79.85-1.1,1.25l-.82,1.11-1.11,1.51A6,6,0,0,1,209.18,175.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,142.33l-1.08-.38-3.22-1.15L176,136.26l.1,0-16.06,25v-.16l12.6,12.81.06.06,0,.09a73.15,73.15,0,0,0-3.42,19v.11l-.09,0-16.29,7.61.1-.21c2,9.15,4.1,18.87,6.32,29.07l-.2-.17,18,.16h.13l.06.12a72.85,72.85,0,0,0,11,15.89l.09.1,0,.13-6.14,16.88-.09-.27,25,16.09-.3,0,12.82-12.59.11-.11.14,0a73,73,0,0,0,19,3.44h.15l.06.14c2.38,5.11,5,10.67,7.6,16.3l-.28-.15,29.06-6.3-.2.25c0-5.67.11-11.8.17-18v-.15l.14-.07a73.12,73.12,0,0,0,15.87-11v0l.12-.1.15,0,16.88,6.15-.3.1,16.1-25,0,.32-12.58-12.83-.11-.11,0-.15a72.29,72.29,0,0,0,3.45-19v-.15l.14-.07,16.3-7.59-.14.28q-3.22-14.89-6.29-29.07l.23.19-18-.18h-.15l-.06-.13a72.5,72.5,0,0,0-11-15.89l-.09-.1,0-.13,6.15-16.88.09.25-25-16.11.25,0-12.84,12.58-.08.08-.11,0a72.57,72.57,0,0,0-19-3.46h-.1l0-.09L238,107.08l.17.08-29.08,6.26.09-.11c-.08,7.2-.14,13.09-.2,18v.05l0,0a74,74,0,0,0-12.3,7.88c-1.26,1-2.17,1.79-2.78,2.31s-.9.78-.9.78,1.12-1.12,3.63-3.15a71.82,71.82,0,0,1,12.27-8l0,.08c0-4.89.09-10.78.14-18v-.09l.09,0,29.06-6.34.12,0,0,.11c2.36,5,4.85,10.36,7.62,16.28l-.15-.09a73,73,0,0,1,19.13,3.44l-.19,0L277.49,114l.11-.11.14.08,25,16.09.15.09-.06.17c-2,5.48-4,11.09-6.14,16.88l-.05-.23a73.25,73.25,0,0,1,11.09,16l-.21-.13,18,.17h.19l0,.19q3.08,14.17,6.31,29.06l0,.2-.18.08-16.29,7.6.14-.22a72.91,72.91,0,0,1-3.46,19.15l-.06-.26,12.59,12.83.14.14-.11.18-16.1,25-.11.17-.19-.07-16.89-6.15.27-.05h0a73.21,73.21,0,0,1-16,11.07l.14-.23c-.06,6.17-.12,12.3-.17,18v.2l-.21.05-29.06,6.29-.2.05-.09-.19-7.59-16.29.21.14a73.09,73.09,0,0,1-19.14-3.47l.25-.06L207.15,279l-.14.13-.16-.1-25-16.11-.16-.1.06-.18c2.15-5.87,4.25-11.65,6.16-16.88l0,.23a73.25,73.25,0,0,1-11.06-16l.19.11-18-.18h-.16l0-.16c-2.2-10.2-4.3-19.92-6.28-29.07l0-.14.13-.07,16.3-7.58-.09.15A73.19,73.19,0,0,1,172.4,174l0,.15-12.57-12.84-.08-.07.06-.09,16.14-25,0-.06.06,0,12.55,4.62,3.22,1.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.42 293.66 268.52 330.66 458.33 330.66 458.33 293.66 326.42 293.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.48 270.81 433.48 274.53 433.48 353.5 487.38 312.15 433.48 270.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,310.5h1.56V316H368v1.27H363Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.34,315.81H370.2l-.6,1.44H368l3-6.75h1.55l3,6.75h-1.64Zm-.5-1.19L371.77,312l-1.07,2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.07,314.28V310.5h1.56v3.72c0,1.29.56,1.82,1.51,1.82s1.5-.53,1.5-1.82V310.5h1.55v3.78a3.06,3.06,0,1,1-6.12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.92,310.5v6.75h-1.28l-3.37-4.1v4.1h-1.54V310.5H385l3.35,4.1v-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.09,313.88a3.72,3.72,0,0,1,6.44-2.3l-1,.93a2.17,2.17,0,0,0-1.7-.79,2.16,2.16,0,1,0,0,4.32,2.15,2.15,0,0,0,1.7-.8l1,.92a3.71,3.71,0,0,1-6.44-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.77,310.5v6.75h-1.56v-2.76h-3.07v2.76h-1.56V310.5h1.56v2.66h3.07V310.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.75,201.31c5.94,75.33,69.14,134.8,146,134.8v-37A109.55,109.55,0,0,1,129.29,189.69s1.65-19.1,2.8-24.85L95.66,158h0C94.33,164.53,92.22,194.67,92.75,201.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,264.89l-.63,2.19,0,.06.86,1.06,1.46-1.19,1,1.2-5.22,4.28-1.85-2.26c-1.14-1.4-1.13-2.86,0-3.82a2.2,2.2,0,0,1,2.53-.28l.72-2.54Zm-3.31,4.6.81,1,1.82-1.49-.81-1c-.6-.74-1.25-.83-1.82-.37S135.84,268.75,136.44,269.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,259.3l1-.75,3.1,4.2-5.42,4-3-4.1,1-.75,2.1,2.86,1.18-.87-1.86-2.52,1-.72,1.86,2.52,1.25-.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,256l7.23-1.33.86,1.28-4,6.17-.94-1.4,2.86-4.39-5.16.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,255.41l-.83-1.33,5.73-3.57.83,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,245.3l1.09-.63,2.62,4.52L123,252.58l-2.56-4.41,1.09-.63,1.78,3.07,1.27-.74L123,247.16l1.06-.61,1.57,2.71,1.35-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,237.75l7-1.09.77,1.49-3.4,3.4,4.77-.71.75,1.48-5,5-.73-1.44,3.53-3.51-4.95.73-.65-1.28,3.55-3.55-5,.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.81 155.68 82.08 135.73 105.61 192.5 154.81 155.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,154.27A109.62,109.62,0,0,1,239,82.46v-37c-63.31,0-117.36,40.38-137.75,96.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.37,103.84l2.53-1.73c1.83-1.25,3.83-1,5,.69s.65,3.64-1.17,4.88l-2.53,1.73Zm5.55,2.83a2.1,2.1,0,1,0-2.36-3.46l-1.18.81,2.36,3.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.36,100.94l.71,1-4.32,2.94L148,99.35l4.21-2.88.71,1-2.93,2,.82,1.21L153.35,99l.68,1-2.58,1.77.88,1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,94.42c.85,1.25.45,2.66-1,3.67l-1.12.77,1,1.54-1.28.88-3.81-5.58,2.41-1.65C157.19,93,158.65,93.17,159.5,94.42Zm-1.3.9c-.42-.62-1.06-.7-1.85-.17l-1,.72,1.32,1.94,1-.72C158.46,96.55,158.61,95.92,158.2,95.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,91.78l1.29-.88,3.09,4.52,2.79-1.91.72,1-4.09,2.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,91.59a3.7,3.7,0,1,1,5,.8A3.5,3.5,0,0,1,165.3,91.59Zm4.8-3.28a2.11,2.11,0,1,0-.53,3A2.06,2.06,0,0,0,170.1,88.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.37,85.91l1.34,2-1.29.88-1.35-2-4.61-2.11,1.37-.93L174,85.19l-.2-3.5,1.27-.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.88 109.59 211.7 56.88 273.18 22.06 259.88 109.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.36,117.7a109.45,109.45,0,0,0-82.42-37.44v-37A146.49,146.49,0,0,1,354.22,93.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.72,68l-2-.77.45-1.19,5.5,2.1-.46,1.19-2-.77-2,5.11-1.45-.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,75.42l-.44,1.18L287,74.72l2.42-6.3,4.76,1.83-.45,1.17-3.31-1.27-.53,1.37,2.93,1.12-.43,1.13-2.93-1.12-.56,1.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.8,76.23l.91-.91a4,4,0,0,0,1.83,1.45c.87.33,1.33.18,1.48-.21.45-1.18-3.53-1.77-2.63-4.11.41-1.07,1.62-1.63,3.41-1a4.59,4.59,0,0,1,2,1.4l-.87.94a3.87,3.87,0,0,0-1.56-1.17c-.86-.33-1.32-.13-1.47.26-.45,1.17,3.52,1.77,2.64,4.08-.41,1-1.62,1.62-3.43.93A4.73,4.73,0,0,1,292.8,76.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,74.59l-2-.77.45-1.19,5.49,2.1-.45,1.19-2-.77-2,5.11L300,79.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,257.15l-33.5-15.71c6.82-14.55,13.08-35.53,13.08-51.75a108.37,108.37,0,0,0-11.73-49.37c-1.35-2.67-6.25-11.54-7.6-13.77l31.66-19.16c1.94,3.22,7.3,13,8.94,16.21a144.9,144.9,0,0,1,15.73,66.09C390.37,211.38,382.94,237.64,373.79,257.15Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.01 143.43 384.02 101.97 325.85 82.16 321.01 143.43",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.29,150.28l.83,2.95c.6,2.13-.27,4-2.23,4.5s-3.66-.54-4.26-2.66l-.83-3Zm-4.45,4.36a2.1,2.1,0,1,0,4-1.13l-.39-1.38-4,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.24,164.52l-1.22.27-1.15-5.09,6.57-1.49,1.13,5-1.22.28-.78-3.46-1.43.33.69,3-1.19.27-.69-3.06-1.52.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,171.05l-7.15-1.69-.27-1.51,6.13-4,.29,1.66-4.38,2.86,5.11,1.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.37,177.74l-1.25.17-.7-5.18,6.69-.9.68,5-1.24.16-.48-3.51-1.45.2.42,3.1-1.2.16-.42-3.1-1.55.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,178.44l.15,1.56-5.45.51.31,3.37-1.26.12-.47-4.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12,184.09a3.7,3.7,0,1,1-3.3,3.86A3.48,3.48,0,0,1,371.12,184.09Zm.29,5.79a2.11,2.11,0,1,0-2.26-2A2.07,2.07,0,0,0,371.41,189.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.46,198.57c-1.51,0-2.45-1.12-2.45-2.92v-1.36h-1.86v-1.56l6.74,0v2.92C374.9,197.43,374,198.56,372.46,198.57Zm0-1.58c.74,0,1.17-.49,1.17-1.44v-1.27h-2.34v1.28C371.28,196.51,371.72,197,372.45,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.94,336.11H125.87v-37H243.94a108.72,108.72,0,0,0,87-43l29.39,22.48A145.47,145.47,0,0,1,243.94,336.11Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.23 246.83 375.01 288.62 370.51 227.34 312.23 246.83",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375,288.62l-4.5-61.28-58.28,19.49,17,11.35a108.63,108.63,0,0,1-85.34,40.93H125.87v37H243.94a145.43,145.43,0,0,0,116.24-57.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M311.35,296.46c.9,1.2.56,2.63-.87,3.71l-1.09.82,1.12,1.48-1.25.94L305.2,298l2.33-1.76C309,295.18,310.44,295.25,311.35,296.46Zm-1.27,1c-.44-.59-1.09-.65-1.85-.08l-1,.77,1.41,1.87,1-.76C310.4,298.63,310.53,298,310.08,297.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76,293.84l1.25-.94,3.29,4.37,2.7-2,.77,1-3.95,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.2,291.86l-2.5,1.89.39,1.51-1.28,1-1.66-7.2,1.23-.93,6.48,3.58-1.31,1Zm-1.11-.65-2.41-1.42.7,2.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3,282.13l4.06,5.39-1,.78-5.16-1.25,2.47,3.27-1.23.93-4.06-5.39,1-.78,5.14,1.25-2.46-3.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.04 276.26 116.04 358.96 169.25 317.61 116.04 276.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.42,
    y: 299.11,
    width: 110.46,
    height: 37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.76,316.36c0,1.5-1.13,2.44-2.94,2.44H58.46v1.86H56.9v-6.75h2.92C61.63,313.91,62.76,314.85,62.76,316.36Zm-1.59,0c0-.74-.48-1.18-1.43-1.18H58.46v2.35h1.28C60.69,317.53,61.17,317.09,61.17,316.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.86,313.91h1.56v5.48h3.39v1.27h-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.19,319.22H71.05l-.59,1.44H68.85l3-6.75h1.55l3,6.75H74.79ZM73.7,318l-1.07-2.59L71.55,318Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,313.91v6.75H82l-3.37-4.1v4.1H77.13v-6.75h1.29l3.35,4.1v-4.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "230.75 449.33 227.91 479.51 211.59 478.3 214.38 448.05 230.75 449.33",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,477.78c-.13,0,.46-6.63,1.34-14.77s1.68-14.73,1.82-14.71-.46,6.62-1.33,14.76S220.09,477.79,220,477.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.1 477.43 211.79 476.17 211.59 478.3 227.91 479.51 228.1 477.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.48,468.63A2.34,2.34,0,0,1,213,468a11.55,11.55,0,0,1,1.61-1.41,11.24,11.24,0,0,1,2.8-1.51,8.75,8.75,0,0,1,3.88-.5,8.65,8.65,0,0,1,6.08,3.38,7.49,7.49,0,0,1,1,1.89,2.06,2.06,0,0,1,.18.76,16.59,16.59,0,0,0-1.48-2.43,8.67,8.67,0,0,0-5.85-3.11,10,10,0,0,0-6.43,1.81C213.3,467.87,212.55,468.7,212.48,468.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "213.59 456.66 213.28 459.99 229.64 461.13 229.88 458.63 213.59 456.66"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "296.36 447.22 298.32 477.47 282.01 478.86 279.99 448.55 296.36 447.22",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.19,477c-.14,0-.59-6.62-1-14.79s-.66-14.81-.53-14.82.6,6.61,1,14.79S290.33,477,290.19,477Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.18 475.39 281.87 476.72 282.01 478.86 298.32 477.47 298.18 475.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.37,469.17s.1-.27.37-.69a11.06,11.06,0,0,1,1.37-1.64,10.94,10.94,0,0,1,2.53-1.93,8.7,8.7,0,0,1,10.28,1.27,7.77,7.77,0,0,1,1.31,1.7,2.21,2.21,0,0,1,.3.72,17.35,17.35,0,0,0-1.85-2.17,8.76,8.76,0,0,0-6.27-2.14,10,10,0,0,0-6.06,2.8C282.05,468.29,281.44,469.22,281.37,469.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.56 457.18 280.79 460.51 297.12 459.05 296.96 456.54 280.56 457.18"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M250.18,179.77l-22.46,3.35-1.06-19.22s-1.62-.07-3-8.27-4.09-22.1-4.09-22.1h0a30.84,30.84,0,0,1,30.31-1.21l1.41.73Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21,143.59c.14-.08,5.58-2.61,6.3,3s-5.29,5.25-5.32,5.08S250.21,143.59,250.21,143.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,146.85c-.16,0-5.56-.55-4.47,5s6.69,3.31,6.67,3.14S222.69,146.85,222.69,146.85Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,142.66c-.11,4.85.46,7.3.17,10.57-.47,5.18-2.41,9.41-6.65,12.65s-10.53,4.21-15.07,1.47c-3.15-1.9-5.54-4.23-6.52-7.7s-2.41-9.66-3-13.22C219.83,140,218.4,134,218.4,134l18.44-6.39L248.65,132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.37,170.27a8.84,8.84,0,0,0,6.4-1.74c-.08-.14-1.41.52-3.16,1S236.37,170.12,236.37,170.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.38,150.81c-.23-4.91-.76-10.49-.8-15.7,0-2,.24-4.82-.25-6.72a15.76,15.76,0,0,0-2.16-5.45,8.44,8.44,0,0,0-6.47-3.36,8.66,8.66,0,0,0-6.74,3,6.53,6.53,0,0,0-6.92-1.44,6.27,6.27,0,0,0-3.91,5.77,4.6,4.6,0,0,0-5.26.3,4.25,4.25,0,0,0-1.13,5A4.25,4.25,0,0,0,216,135a4,4,0,0,0,.94,3.77c1.09,1.17,2.79,1.63,4,2.72a4.61,4.61,0,0,1,1.11,5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.19,137.65a1.37,1.37,0,0,0,.3.49,3.81,3.81,0,0,0,1.3,1,4.15,4.15,0,0,0,2.59.36,4.38,4.38,0,0,0,2.82-1.87l-.42,0a3.92,3.92,0,0,0,3,2.4,4.77,4.77,0,0,0,4.2-1.22,6.28,6.28,0,0,0,1.91-3.43l-.45.12a5.49,5.49,0,0,0,4.67,1.58,5.09,5.09,0,0,0,3.38-2,4.84,4.84,0,0,0,1-2.36,2,2,0,0,0,0-.91s0,.32-.14.88a5.24,5.24,0,0,1-1.05,2.2,4.85,4.85,0,0,1-3.18,1.77,5.05,5.05,0,0,1-4.22-1.49l-.35-.37-.1.5a5.94,5.94,0,0,1-1.77,3.15,4.22,4.22,0,0,1-3.72,1.09,3.45,3.45,0,0,1-2.66-2l-.16-.46-.26.42a4,4,0,0,1-2.5,1.74,3.94,3.94,0,0,1-2.39-.24A5.46,5.46,0,0,1,223.19,137.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.87,135.41a4.85,4.85,0,0,1,.48-2.17,3.48,3.48,0,0,1,1.78-1.62,3.73,3.73,0,0,1,3,.06l.52.25-.14-.54a4.14,4.14,0,0,1-.07-1.65,4.51,4.51,0,0,1,1.91-3,4.68,4.68,0,0,1,2.92-.73,6.53,6.53,0,0,1,2.69.94s-.16-.24-.58-.54a4.57,4.57,0,0,0-2.07-.77,5,5,0,0,0-3.23.7,4.89,4.89,0,0,0-2.17,3.33,4.41,4.41,0,0,0,.09,1.85l.37-.3a4.19,4.19,0,0,0-3.4,0A3.75,3.75,0,0,0,223,133.1a3.57,3.57,0,0,0-.32,1.71C222.75,135.21,222.84,135.42,222.87,135.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,133.62c.07,0-.07-.32-.11-.78a3.57,3.57,0,0,1,.32-1.75c.29-.64.65-1.31.86-1.67a.56.56,0,0,1,.59-.21s0-.13-.17-.21a.67.67,0,0,0-.7.17,4.27,4.27,0,0,0-.55.75,6,6,0,0,0-.52,1,3,3,0,0,0-.21,2C234.67,133.44,235,133.66,235,133.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,124.73c.06,0-.06-.44-.52-1a3,3,0,0,0-1-.74A2.41,2.41,0,0,0,242,123a3.73,3.73,0,0,0-2.08,1.77c-.34.58-.48,1-.42,1s.33-.3.74-.81a4,4,0,0,1,1.91-1.47,2.28,2.28,0,0,1,2.18.57C244.8,124.44,245,124.77,245.11,124.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,149a9.22,9.22,0,0,0,1.42-3.91,8.79,8.79,0,0,0,.05-4.13c-.16,0-.17,1.84-.58,4S245.87,149,246,149Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.69,150.8a6.85,6.85,0,0,0,1-2.78,6.75,6.75,0,0,0,.24-2.93,10.51,10.51,0,0,0-.76,2.83A10,10,0,0,0,243.69,150.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.76,153.77a8.71,8.71,0,0,0,1.45,4.83,9.1,9.1,0,0,0,3.56,3.66,31.26,31.26,0,0,1-3.09-3.92A30.22,30.22,0,0,1,227.76,153.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.54,150.08a8.54,8.54,0,0,0,3,8.23,24.15,24.15,0,0,1-2.12-3.89A24.68,24.68,0,0,1,224.54,150.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.74 179.23 226.94 174.41 250.42 169.45 251.25 173.42 226.74 179.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.23,237.54s-1.16.6-.36,1.45,11.49,10.33,12.94,11.26a30.43,30.43,0,0,0,5.76,2.05l2.82-.52L176,245l2-3.28-.51-.75,1.87-7.27s-1.62-.66-2.37.51c-1.05,1.65-2.5,4.33-2.5,4.33s-2.94.44-4-.83-7.29-11.78-8-12-1.9,0-1.29,1.71,4.59,7.63,4.44,8-.76.77-1,.48-6.64-8.67-7.65-8.82-1.84.72-.86,2.33,6.16,7.52,5.92,7.9-.92-.08-.92-.08-5.91-6.17-6.74-6.06-1.07,1-.6,1.81,6.45,6.56,6.56,7c.07.3-.18,1.49-.67,1.08S153.7,237.15,153.23,237.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,299l-1.24,80.68-2.74,83.75L232.35,465,240,379.64l8.73-60.59,1.92-.12L267.84,382,278.55,463C279.88,462.63,300,461,300,461L286,297.13l-2.33-13.63-59.84,1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,255.51l-1.73-46.66-2.88-32.22H256.65l-5-4.89-25.17,4.89-2.33,7s-20.21,6.43-21.33,8.39c0,0,7.09,28,10.43,43.66,2.29,10.76,4.7,21.79,4.7,21.79l-6.38,51.61c-.26,0,38.88-1.72,38.88-1.72l37.8-4.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.32,162s-5.76.45-6.1.45S289,163,289,163a3,3,0,0,1,1.63-2c1.37-.61,4-1.56,4.24-2s.87-1.16.33-1.91-10.48-10.84-10.82-11.38-.89-1.57,0-1.77,2,.75,2.73,1.36,4.61,3.88,5,3.68.07-.55.07-.55-6.57-6.76-6.64-7-.84-2.2,1-1.87c.9.15,7.72,7.13,8,6.85s-5.73-8-5.18-8.58,1.16-1.23,2.25,0,5.78,7.49,6.13,7.56a.57.57,0,0,0,.61-.75c-.13-.47-2.92-5.33-2.92-5.88s.54-.68,1.09-.75,6.4,8.4,6.4,8.4,4.52,7.27,5,8.11a28,28,0,0,1,1.3,3.68Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,162.33l3.92,15.14-9,3.36-19.34-4.2v28.59l2.74,7.43S318.7,193.12,321.39,191c5-4-2.95-17.86-2.95-17.86l-7.35-15.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.81,192.05l-4.53,9.07L186.84,239l-12.78,3.41-2.4,11.68s20,4.69,23.7,3.08c6.29-2.73,16.8-28.81,16.8-28.81l-1.42-22.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5,183.66a36.57,36.57,0,0,0-6-4.12,35.88,35.88,0,0,0-6.85-2.37,6.57,6.57,0,0,1,2.15.2,19.12,19.12,0,0,1,4.93,1.71,19.4,19.4,0,0,1,4.3,3A6.28,6.28,0,0,1,316.5,183.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.69,177.39a27.32,27.32,0,0,0-4.89-.38,28,28,0,0,0-4.79,1,10.34,10.34,0,0,1,9.68-.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.65,176.63a6.32,6.32,0,0,1-1.1.76c-.36.24-.81.51-1.35.8s-1.15.63-1.85,1a46.21,46.21,0,0,1-5,2.07A62.76,62.76,0,0,1,241,183a67.54,67.54,0,0,1-11.93,1.53c-1.54.06-2.78.06-3.64,0a7.27,7.27,0,0,1-1.34-.1,6.63,6.63,0,0,1,1.34-.11c.85,0,2.09-.09,3.62-.19a79.62,79.62,0,0,0,11.83-1.67c2.28-.51,4.42-1.12,6.34-1.74s3.61-1.31,5-2c.7-.3,1.32-.61,1.86-.88s1-.5,1.39-.72A6.62,6.62,0,0,1,256.65,176.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.58,257.54a7,7,0,0,1-1.44.37c-.94.21-2.3.45-4,.68a65.72,65.72,0,0,1-26.56-2c-1.65-.48-3-.92-3.85-1.27a8.78,8.78,0,0,1-1.37-.58,6.91,6.91,0,0,1,1.43.39c.91.29,2.24.67,3.89,1.11a72.9,72.9,0,0,0,26.41,2c1.7-.18,3.07-.36,4-.51A9.26,9.26,0,0,1,262.58,257.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.13,242.46c-.14,0,1.27-5.27,3.14-11.68s3.49-11.57,3.63-11.53-1.26,5.26-3.13,11.68S186.27,242.5,186.13,242.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5,272.66c.15,0,.41,5.82.59,13s.2,13,.06,13-.41-5.81-.58-13S247.36,272.67,247.5,272.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.84,316.9c0,.14-5.06,1.19-11.36,2.35s-11.42,2-11.45,1.83,5.06-1.19,11.36-2.35S261.81,316.76,261.84,316.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,378.11a45.77,45.77,0,0,0-6.55.84,48.09,48.09,0,0,0-6.19,2.26,5.74,5.74,0,0,1,1.63-1.09,19.49,19.49,0,0,1,4.44-1.67,19.3,19.3,0,0,1,4.71-.56A5.56,5.56,0,0,1,284.92,378.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17,382c0,.15-1.88-.23-4.18-.12s-4.11.63-4.15.48a11,11,0,0,1,8.33-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.94,257.5a2.33,2.33,0,0,1-.16-.51c-.1-.4-.23-.89-.37-1.49-.32-1.37-.76-3.23-1.28-5.49-1.06-4.71-2.49-11.09-4.07-18.14s-3-13.44-4.05-18.15c-.51-2.26-.93-4.13-1.23-5.5l-.32-1.5a1.88,1.88,0,0,1-.08-.53,2,2,0,0,1,.18.51c.11.39.25.88.41,1.47.35,1.29.83,3.16,1.39,5.47,1.14,4.62,2.62,11,4.2,18.11s3,13.52,3.93,18.18c.46,2.28.84,4.15,1.11,5.52.11.61.21,1.11.28,1.51A1.82,1.82,0,0,1,217.94,257.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.18,192.79a1.76,1.76,0,0,1,.05.29l.07.84c.07.73.16,1.82.24,3.23.2,2.8.42,6.87.67,11.89.5,10,1.09,23.92,1.66,39.25.09,2.47.18,4.91.27,7.21v0c2,13.49,3.85,25.43,5.15,34,.62,4.26,1.13,7.7,1.48,10.11.16,1.16.28,2.07.37,2.73,0,.29.07.52.09.71a.62.62,0,0,1,0,.24.79.79,0,0,1-.06-.23c0-.19-.08-.42-.13-.71-.11-.65-.27-1.56-.47-2.71-.39-2.41-.94-5.84-1.63-10.09-1.35-8.6-3.21-20.53-5.32-34h0v0c-.08-2.31-.17-4.74-.27-7.21C279.17,218,278.29,195.63,278.18,192.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.05,178.39c-9.46,3.82-18.8,6.17-29,6.18a8.22,8.22,0,0,0,5.29,2.33,21.21,21.21,0,0,0,5.94-.51,88.82,88.82,0,0,0,14.44-4.06C252.39,181.73,254.27,180,254.05,178.39Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.94,207.82c.16,3.64-.25,8,.52,11.59A21.59,21.59,0,0,0,212,229.2C210.25,222.34,208.76,214.82,206.94,207.82Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.28,262.73l-.31-.05c3.06,3.48,8.14,3.84,12.78,3.87s9.66-.26,12.77-3.7A62.73,62.73,0,0,1,236.28,262.73Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.39,415.74c1.21,3.76,5.66,6.37,9.34,5,2.09-.79,3.6-2.61,4.89-4.43a20.41,20.41,0,0,1,4.3-5.07A6.32,6.32,0,0,1,90.31,410L73.4,403.64C66.16,408,66.18,412,67.39,415.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.39,415.74c1.21,3.76,5.66,6.37,9.34,5,2.09-.79,3.6-2.61,4.89-4.43a20.41,20.41,0,0,1,4.3-5.07A6.32,6.32,0,0,1,90.31,410L73.4,403.64C66.16,408,66.18,412,67.39,415.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.39,415.74c1.21,3.76,5.66,6.37,9.34,5,2.09-.79,3.6-2.61,4.89-4.43a20.41,20.41,0,0,1,4.3-5.07A6.32,6.32,0,0,1,90.31,410L73.4,403.64C66.16,408,66.18,412,67.39,415.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,420.21a14.29,14.29,0,0,0-23.41,5.62l1.69,6.55a8,8,0,0,1,4.16-5.31c2.21-1,4.78-.41,7,.41s4.5,1.93,6.92,2.08,5.13-1,5.85-3.3S153.21,421.78,151.58,420.21Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.58,420.21a14.29,14.29,0,0,0-23.41,5.62l1.69,6.55a8,8,0,0,1,4.16-5.31c2.21-1,4.78-.41,7,.41s4.5,1.93,6.92,2.08,5.13-1,5.85-3.3S153.21,421.78,151.58,420.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M110.76,442.06c-3.54-3.36-3.36-9.21-1.6-13.76s5.62-8,9.92-10.34a31.42,31.42,0,0,1,27.37-.89,13,13,0,0,0-10.5,6.17c-1.94,3.22-2.37,7.13-4,10.53a16.57,16.57,0,0,1-21.22,8.29",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06,421.87c-3.92-4.62-4.44-12-3.86-18.07s2-12.1,1-18.09c-.56-3.54-1.94-6.93-2.4-10.49s.19-7.58,3-9.88c3.17-2.64,8.16-2,11.46.47s5.21,6.37,6.6,10.25c3.07,8.53,4.2,18,1.68,26.69s-8.44,16.49-17.11,19.12",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18,459.8a2.67,2.67,0,0,1,0-.53c0-.35,0-.87,0-1.53,0-1.33.18-3.24.48-5.6a75.62,75.62,0,0,1,1.5-8.2,37.58,37.58,0,0,1,3.75-9.49,39.22,39.22,0,0,1,6.11-8.17,38.78,38.78,0,0,1,6.41-5.33c1-.68,1.92-1.19,2.74-1.67s1.56-.8,2.16-1.09l1.41-.59a2.72,2.72,0,0,1,.5-.18l-.48.24-1.38.65c-.58.3-1.3.68-2.12,1.13s-1.74,1-2.7,1.7a39.93,39.93,0,0,0-12.37,13.47c-3.6,6.3-4.59,12.92-5.3,17.56-.33,2.35-.49,4.26-.58,5.58,0,.64-.07,1.14-.09,1.52A3.13,3.13,0,0,1,107.18,459.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,408.43c1.89-2.62,6.57-3.38,9.53-2.07s5.12,3.9,7.06,6.48,3.82,5.32,6.5,7.12,6.44,2.45,9.11.64a7.83,7.83,0,0,0,3.1-5.36,18,18,0,0,0-.43-6.32c-.64-3-1.68-6.21-4.11-8.14-2.71-2.16-6.48-2.26-9.93-2.14a37.15,37.15,0,0,0-11.73,1.8c-3.72,1.38-7.52,4.35-9.1,8",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,454s0-.06,0-.16,0-.28,0-.47q0-.66-.06-1.8c0-1.59-.11-3.84-.19-6.61s-.2-6.12-.4-9.8-.48-7.74-1-12a38.59,38.59,0,0,0-1.2-6.07A31.44,31.44,0,0,0,96,411.82a30.19,30.19,0,0,0-2.8-4.4,29.13,29.13,0,0,0-3.06-3.36,22.56,22.56,0,0,0-5.42-3.7c-.36-.16-.67-.32-.94-.43l-.71-.27-.44-.18-.14-.07s.05,0,.15,0l.45.14.72.25c.28.1.6.26,1,.41a21.84,21.84,0,0,1,5.52,3.64,28.49,28.49,0,0,1,3.12,3.36,29.86,29.86,0,0,1,2.85,4.43A30.93,30.93,0,0,1,98.52,417a38.32,38.32,0,0,1,1.22,6.12c.56,4.23.83,8.29,1,12s.27,7,.33,9.81.08,5.06.09,6.62v1.8c0,.19,0,.34,0,.47A1.08,1.08,0,0,1,101.16,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77,457.27a20.2,20.2,0,0,1-.8-3.11,32.53,32.53,0,0,1-.33-8.74,58,58,0,0,1,2.76-12.69c1.49-4.66,3.51-9.64,5.23-15a68,68,0,0,0,2.08-7.94,68.79,68.79,0,0,0,1-7.57,109.61,109.61,0,0,0,.23-13c-.13-3.69-.32-6.67-.44-8.73-.06-1-.11-1.82-.14-2.38l0-.62q0-.21,0-.21l0,.21c0,.16,0,.36.06.62,0,.56.12,1.35.2,2.37.16,2.06.39,5,.55,8.73a106.66,106.66,0,0,1-.16,13,69.38,69.38,0,0,1-1,7.61,66.65,66.65,0,0,1-2.08,8c-1.73,5.37-3.76,10.35-5.26,15a58.9,58.9,0,0,0-2.81,12.61,33.46,33.46,0,0,0,.23,8.7c.17,1,.34,1.8.48,2.32q.09.38.15.6C103.76,457.2,103.77,457.27,103.77,457.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.73 460.55 87.71 460.55 86.93 454 121.73 454 121.73 460.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.36 459.8 95.61 479.44 114.1 479.44 118.08 459.8 91.36 459.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,460.55c0,.09-7.48.14-16.71.11s-16.7-.12-16.7-.21,7.48-.14,16.7-.11S121.73,460.46,121.73,460.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.89,470.24a14.3,14.3,0,0,0-3-1.72,10.87,10.87,0,0,0-3.64-.73,12.74,12.74,0,0,0-4.48.83c-1.55.52-3,1.13-4.41,1.47a10.57,10.57,0,0,1-3.81.11,8.13,8.13,0,0,1-2.45-.77,6.31,6.31,0,0,1-.59-.38c-.13-.1-.19-.15-.18-.16s.29.17.83.42a8.28,8.28,0,0,0,2.42.66,10.59,10.59,0,0,0,3.71-.17c1.37-.35,2.81-1,4.38-1.49a12.51,12.51,0,0,1,4.59-.81,10.22,10.22,0,0,1,3.72.81,9.67,9.67,0,0,1,2.22,1.3,6.49,6.49,0,0,1,.53.45C115.84,470.17,115.9,470.23,115.89,470.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.63,471.55a15,15,0,0,0-2.88-1.69,9.66,9.66,0,0,0-3.51-.72,12.53,12.53,0,0,0-4.33.78c-1.5.5-2.91,1.08-4.25,1.44a10.92,10.92,0,0,1-3.66.41,6.13,6.13,0,0,1-2.4-.64,4.83,4.83,0,0,1-.58-.36c-.12-.1-.18-.15-.17-.16s.28.16.8.4a6.54,6.54,0,0,0,2.36.53,11.11,11.11,0,0,0,3.57-.47c1.31-.37,2.71-1,4.22-1.46a12.39,12.39,0,0,1,4.45-.77,9.7,9.7,0,0,1,5.72,2.09c.23.19.39.34.5.45A1.11,1.11,0,0,1,115.63,471.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,468.94a16.32,16.32,0,0,0-3.08-1.81,11.41,11.41,0,0,0-3.73-.9,12.27,12.27,0,0,0-4.63.81,40.85,40.85,0,0,1-4.56,1.49,11.55,11.55,0,0,1-3.94,0,8.86,8.86,0,0,1-2.53-.8,4.21,4.21,0,0,1-.61-.38c-.13-.1-.2-.15-.19-.16s.3.17.86.43a9.84,9.84,0,0,0,2.51.68,11.63,11.63,0,0,0,3.84-.07,45.83,45.83,0,0,0,4.52-1.5,12.11,12.11,0,0,1,4.74-.81,11.57,11.57,0,0,1,6.08,2.35c.25.2.43.36.55.47A1,1,0,0,1,116.23,468.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,460.57c0,.09-7.65.17-17.09.17s-17.1-.08-17.1-.17,7.66-.16,17.1-.16S122,460.48,122,460.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.23,479.29c0,.15-91.45.27-204.22.27s-204.25-.12-204.25-.27S137.19,479,250,479,454.23,479.15,454.23,479.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.23,164.89l-11-2.46a26.38,26.38,0,1,1,4.86-8.08h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,164.89l-6-10.6a.11.11,0,0,0-.14,0l0,0v0l.18.09a26.23,26.23,0,0,0,1.41-13.62,22.53,22.53,0,0,0-1-4c-.25-.68-.48-1.37-.75-2.06l-1-2A26.47,26.47,0,0,0,187,120a26.31,26.31,0,0,0-11-1.3,26.81,26.81,0,0,0-11.1,3.71,26,26,0,0,0-8.71,8.55,26.39,26.39,0,0,0-4,11.81,26.88,26.88,0,0,0,1.71,11.81,25.76,25.76,0,0,0,6.22,9.42,26.68,26.68,0,0,0,18.34,7.46,28.35,28.35,0,0,0,8.51-1.41,26.18,26.18,0,0,0,11.33-7.56l-.09,0,11,2.37-11-2.56a.12.12,0,0,0-.1,0,26,26,0,0,1-11.27,7.43,28.08,28.08,0,0,1-8.42,1.36,26.44,26.44,0,0,1-18.09-7.41,25.67,25.67,0,0,1-6.11-9.3,26.42,26.42,0,0,1-1.67-11.64,25.93,25.93,0,0,1,3.91-11.62,25.48,25.48,0,0,1,8.57-8.43A26.54,26.54,0,0,1,176,119.09a25.91,25.91,0,0,1,10.86,1.25,26.36,26.36,0,0,1,14.73,12.45c.32.68.64,1.35,1,2s.5,1.36.75,2a23.73,23.73,0,0,1,1,4,26.22,26.22,0,0,1-1.33,13.5.1.1,0,0,0,.06.13.09.09,0,0,0,.11,0H203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.02 145.57 167.79 141.8 175.07 148.27 189.36 134.52 192.86 138.29 174.53 155.54 164.02 145.57",
    style: {
      fill: "#92E3A9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduceProduct);
export default __webpack_public_path__ + "static/media/produce-product.85ae442360e8ebabbca9a34d466c2503.svg";
export { ForwardRef as ReactComponent };